/// <reference path="../../../../typings/index.d.ts" />
angular.module('app').factory('ManageSimulatorServiceApi', ($http, ApiErrorService) => {
    return {
        getSimulatorById: getSimulatorById,
        getAllSimulatorsWithLinking: getAllSimulatorsWithLinking,
        getAllSimulatorsShort: getAllSimulatorsShort,
        getSimulatorCategoryList: getSimulatorCategoryList,
        getTestModeList: getTestModeList,
        getMessageProtocolList: getMessageProtocolList,
        saveSimulator: saveSimulator,
        deactivateSimulator: deactivateSimulator,
        unlinkSimulator: unlinkSimulator,
        linkSimulator: linkSimulator,
        getEmptySimulatorDto: getEmptySimulatorDto,
        validateSimulatorDetails: validateSimulatorDetails,
        publicKeyUpload: publicKeyUpload,
        getSimulatorConfigs: getSimulatorConfigs,
        saveSimulatorOptions: saveSimulatorOptions
    };
    function getSimulatorById(simId, userId) {
        return $http.get(`api/ManageSimulator/GetSimulatorById?simId=${simId}&userId=${userId}`, null)
            .then(function (response) {
            return response;
        }, function (response) {
            ApiErrorService.error(response);
        });
    }
    function getAllSimulatorsWithLinking(linkableOnly) {
        return $http.get(`api/ManageSimulator/GetAllSimulatorsWithLinking?linkableOnly=${linkableOnly}`, null)
            .then(function (response) {
            return response;
        }, function (response) {
            ApiErrorService.error(response);
        });
    }
    function getAllSimulatorsShort() {
        return $http.get(`api/ManageSimulator/GetAllSimulatorsShort`, null)
            .then(function (response) {
            return response;
        }, function (response) {
            ApiErrorService.error(response);
        });
    }
    function getSimulatorCategoryList() {
        return $http.get(`api/ManageSimulator/GetSimulatorCategoryList`, null)
            .then(function (response) {
            return response;
        }, function (response) {
            ApiErrorService.error(response);
        });
    }
    function getTestModeList() {
        return $http.get(`api/ManageSimulator/GetTestModeList`, null)
            .then(function (response) {
            return response;
        }, function (response) {
            ApiErrorService.error(response);
        });
    }
    function getMessageProtocolList() {
        return $http.get(`api/ManageSimulator/GetMessageProtocolList`, null)
            .then(function (response) {
            return response;
        }, function (response) {
            ApiErrorService.error(response);
        });
    }
    function saveSimulator(simulator) {
        return $http.post(`api/ManageSimulator/SaveSimulator`, simulator)
            .then(function (response) {
            return response;
        }, function (response) {
            ApiErrorService.error(response);
        });
    }
    function deactivateSimulator(simId) {
        return $http.post(`api/ManageSimulator/DeactivateSimulator?simId=${simId}`, null)
            .then(function (response) {
            return response;
        }, function (response) {
            ApiErrorService.error(response);
        });
    }
    function unlinkSimulator(simId, linkedSimId) {
        return $http.post(`api/ManageSimulator/UnlinkSimulator?simId=${simId}&linkedSimId=${linkedSimId}`, null)
            .then(function (response) {
            return response;
        }, function (response) {
            ApiErrorService.error(response);
        });
    }
    function linkSimulator(primarySimId, secondarySimId) {
        return $http.post(`api/ManageSimulator/LinkSimulator?primarySimId=${primarySimId}&secondarySimId=${secondarySimId}`, null)
            .then(function (response) {
            return response;
        }, function (response) {
            ApiErrorService.error(response);
        });
    }
    function getEmptySimulatorDto() {
        return $http.get(`api/ManageSimulator/GetEmptySimulatorDto`, null)
            .then(function (response) {
            return response;
        }, function (response) {
            ApiErrorService.error(response);
        });
    }
    function validateSimulatorDetails(simulator) {
        return $http.post(`api/ManageSimulator/ValidateSimulatorDetails`, simulator)
            .then(function (response) {
            return response;
        }, function (response) {
            ApiErrorService.error(response);
        });
    }
    function publicKeyUpload(request) {
        return $http.post(`api/ManageSimulator/PublicKeyUpload`, request)
            .then(function (response) {
            return response;
        }, function (response) {
            ApiErrorService.error(response);
        });
    }
    function getSimulatorConfigs(userId, simId) {
        return $http.get(`api/ManageSimulator/GetSimulatorConfigs?userId=${userId}&simId=${simId}`, null)
            .then(function (response) {
            return response;
        }, function (response) {
            ApiErrorService.error(response);
        });
    }
    function saveSimulatorOptions(userId, simId, simOptions) {
        return $http.post(`api/ManageSimulator/SaveSimulatorOptions?userId=${userId}&simId=${simId}`, simOptions)
            .then(function (response) {
            return response;
        }, function (response) {
            ApiErrorService.error(response);
        });
    }
});
